/* @flow */
import * as React from 'react';

import { mountModal } from 'lib/modal';
import Glyph from 'components/Glyph';
import type { GlyphSize } from 'components/Glyph';
import Button, { ButtonSize } from 'components/ButtonDeprecated';
import PhoneCallModal, { isFixableDenialReason } from 'phoneCalls/components/PhoneCallModal';
import type { DenialReason } from 'phoneCalls/components/PhoneCallModal';
import PhoneCallDenialReasonTooltip from 'phoneCalls/components/PhoneCallDenialReasonTooltip';

type Props = {
  className?: ?string,
  calleeUuid: string,
  calleeName: string,
  inline?: boolean,
  size?: $Values<typeof ButtonSize>,
  denialReason?: DenialReason,
  glyphSize?: GlyphSize,
};

type State = {
  glyphFilled: boolean,
};

class PhoneCallButton extends React.Component<Props, State> {
  state: State = {
    glyphFilled: false,
  };

  static defaultProps = {
    glyphSize: 'medium',
    onMouseEnter: () => {},
  };

  showCallModal = () => {
    mountModal(<PhoneCallModal calleeUuid={this.props.calleeUuid} />, this);
  };

  toggleFill = () => {
    const { glyphFilled } = this.state;
    this.setState({
      glyphFilled: !glyphFilled,
    });
  };

  render() {
    const { denialReason, calleeName, glyphSize } = this.props;
    const { glyphFilled } = this.state;
    const buttonProps = {
      'aria-label': 'Call',
      eventElementName: 'call_user_button',
      size: this.props.size || ButtonSize.xxsmall,
      className: this.props.className,
      onClick: this.showCallModal,
      disabled: denialReason && !isFixableDenialReason(denialReason),
    };
    const color = denialReason ? 'graphite' : 'mascot';
    return (
      <PhoneCallDenialReasonTooltip denialReason={denialReason} calleeName={calleeName}>
        {this.props.inline ? (
          <div style={{ display: 'inline-block' }}>
            {/* eslint-disable-next-line @remind/remind/icon-only-buttons-require-aria-label */}
            <Button {...buttonProps} level="text">
              <Glyph
                onMouseOver={this.toggleFill}
                onMouseLeave={this.toggleFill}
                name={glyphFilled && !denialReason ? 'phone-filled' : 'phone'}
                color={color}
                solo
                size={glyphSize}
              />
            </Button>
          </div>
        ) : (
          <div>
            {/* eslint-disable-next-line @remind/remind/icon-only-buttons-require-aria-label */}
            <Button {...buttonProps} color="mascot" level="secondary">
              <Glyph name="phone" solo size={glyphSize} />
            </Button>
          </div>
        )}
      </PhoneCallDenialReasonTooltip>
    );
  }
}

export default PhoneCallButton;
